module.exports = __webpack_public_path__ + "img/logo-tela-login.35ffecba.png";